import classNames from 'classnames';
import React from 'react';
import GridTheadSort from '../sort/GridTheadSort/GridTheadSort';

import { TheadComponent, TrHeadComponent, TdHeadComponent } from '../wrappers';
import css from './GridThead.module.scss';
import { getThDivStyles, getThStyles } from '../helpers';
import { generateStylers } from '../../../../common/utils/styles';
import { Tooltip, svgSprite } from '../../../../hybrid/wrappers';

const GridThead = ({
    gridName,
    cellThAddButton,
    widthArr,
    thead,
    gridStyles = {},
    rowRef,
    sticky,
    fixedLastColumnShow,
    pageSettings,
    isFixedColumn
}) => {
    const trStyle = generateStylers(gridStyles?.th);
    return (
        <TheadComponent sticky={sticky}>
            <TrHeadComponent
                rowRef={rowRef}
                sticky={sticky}
                className={classNames(css.rowThWeb, trStyle.className)}
                style={trStyle.style}
            >
                {thead.map((data, idx) => (
                    <TdHeadComponent
                        sticky={sticky}
                        key={`${gridName}th${idx}`}
                        {...{
                            [isFixedColumn ? 'data-thead-copy-fixed' : 'data-thead-copy']:
                                sticky?.rightStickyColumnName === data.name ? `${gridName}` : undefined
                        }}
                        {...getThStyles(css, gridStyles, widthArr, idx, data, thead, sticky, fixedLastColumnShow)}
                    >
                        <div
                            {...getThDivStyles(css, data, idx, gridStyles)}
                            {...(!!cellThAddButton && !!cellThAddButton[idx] && !!cellThAddButton[idx].handlers
                                ? cellThAddButton[idx].handlers
                                : {})}
                        >
                            <p>{data.title ? data.title : sticky?.rightStickyColumnName ? 'ㅤ' : ''}</p>
                            {data.hint ? (
                                <Tooltip compStyle={{ inner: css.rowThInfo }} text={data.hint}>
                                    {svgSprite('question-circle-fill', {
                                        className: css.rowThInfoSvg
                                    })}
                                </Tooltip>
                            ) : null}

                            {!!cellThAddButton &&
                                !!cellThAddButton[idx] &&
                                !!cellThAddButton[idx].comp &&
                                cellThAddButton[idx].comp}
                            {pageSettings && pageSettings?.sort && pageSettings?.sort[data?.name] ? (
                                <GridTheadSort sortData={pageSettings?.sort[data?.name]} />
                            ) : null}
                        </div>
                    </TdHeadComponent>
                ))}
            </TrHeadComponent>
        </TheadComponent>
    );
};

export default GridThead;
